window.tinymce.PluginManager.add('symbolpicker', function (editor) {
  const symbols = [
    { title: 'Math Symbols', symbols: ['±', '√', '∑', '∞', '≈', '≠', '≤', '≥'] },
    { title: 'Currency Symbols', symbols: ['$', '€', '£', '¥', '₹', '₩', '₪', '฿'] },
    {
      title: 'Greek Letters',
      symbols: [
        'α',
        'β',
        'γ',
        'δ',
        'ε',
        'ζ',
        'η',
        'θ',
        'ι',
        'κ',
        'λ',
        'μ',
        'ν',
        'ξ',
        'ο',
        'π',
        'ρ',
        'σ',
        'τ',
        'υ',
        'φ',
        'χ',
        'ψ',
        'ω'
      ]
    },
    { title: 'Arrows', symbols: ['←', '↑', '→', '↓', '↔', '↕', '⇐', '⇑', '⇒', '⇓', '⇔', '⇕'] },
    { title: 'Miscellaneous', symbols: ['©', '®', '™', '✓', '✔', '✕', '✖', '★', '☆', '✂', '♥'] },
    {
      title: 'Outlined Symbols',
      symbols: ['⭕', '❌', '✅', '✳️', '❎', '⚪', '⚫', '⚪️', '⚫️']
    },
    {
      title: 'Emojis',
      symbols: [
        '😀',
        '😂',
        '😃',
        '😄',
        '😁',
        '😆',
        '😅',
        '🤣',
        '😊',
        '😇',
        '🙂',
        '🙃',
        '😉',
        '😌',
        '😍',
        '😘',
        '😗',
        '😙',
        '😚',
        '😋',
        '😜',
        '😝',
        '😛',
        '🤑',
        '🤗',
        '🤔',
        '🤐',
        '🤨',
        '😐',
        '😑',
        '😶',
        '😏',
        '😒',
        '🙄',
        '😬',
        '🤥',
        '😌',
        '😔',
        '😪',
        '😴',
        '🤒',
        '🤕',
        '🤢',
        '🤧',
        '😷',
        '🤮',
        '🤯',
        '🤠',
        '😎',
        '🤓',
        '🧐',
        '😕',
        '😟',
        '🙁',
        '☹',
        '😮',
        '😯',
        '😲',
        '😳',
        '🥺',
        '😦',
        '😧',
        '😨',
        '😰',
        '😥',
        '😢',
        '😭',
        '😱',
        '😖',
        '😣',
        '😞',
        '😓',
        '😩',
        '😫',
        '🥱',
        '😤',
        '😡',
        '😠',
        '🤬',
        '😈',
        '👿',
        '👹',
        '👺',
        '💀',
        '👻',
        '👽',
        '👾',
        '🤖',
        '💩',
        '😺',
        '😸',
        '😹',
        '😻',
        '😼',
        '😽',
        '🙀',
        '😿',
        '😾',
        '🙈',
        '🙉',
        '🙊',
        '💋',
        '💌',
        '💘',
        '💝',
        '💖',
        '💗',
        '💓',
        '💞',
        '💕',
        '💟',
        '❣️',
        '💔',
        '❤️',
        '🧡',
        '💛',
        '💚',
        '💙',
        '💜',
        '🤎',
        '🖤',
        '🤍',
        '💯',
        '💢',
        '💥',
        '💫',
        '💦',
        '💨',
        '🕳️',
        '💣',
        '💬',
        '👁️‍🗨️',
        '🗨️',
        '🗯️',
        '💭'
      ]
    },
    {
      title: 'Roman Numerals',
      symbols: ['Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ', 'Ⅸ', 'Ⅹ', 'Ⅺ', 'Ⅻ']
    }
  ];

  editor.ui.registry.addNestedMenuItem('symbolpicker', {
    text: 'Insert Symbol',
    getSubmenuItems: function () {
      return symbols.map(category => ({
        type: 'nestedmenuitem',
        text: category.title,
        getSubmenuItems: function () {
          return category.symbols.map(symbol => ({
            type: 'menuitem',
            text: symbol,
            onAction: function () {
              editor.insertContent(symbol);
            }
          }));
        }
      }));
    }
  });

  editor.ui.registry.addMenuButton('symbolpicker', {
    text: 'Symbols',
    icon: 'insert',
    tooltip: 'Insert Symbol',
    fetch: function (callback) {
      const items = symbols.map(category => ({
        type: 'nestedmenuitem',
        text: category.title,
        getSubmenuItems: function () {
          return category.symbols.map(symbol => ({
            type: 'menuitem',
            text: symbol,
            onAction: function () {
              editor.insertContent(symbol);
            }
          }));
        }
      }));
      callback(items);
    }
  });
});
